type OutputLanguage = 'Deutsch' | 'Englisch';

const replaceCustomerPrefixPlaceholder = (
  text: string,
  outputLanguage: OutputLanguage,
): string => {
  const customerPrefix = outputLanguage === 'Englisch' ? 'Customer' : 'Kunde';
  return text.replace(/\$\{CustomerPrefix\}/g, customerPrefix);
};

export default replaceCustomerPrefixPlaceholder;
